import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { pageLoadTrackerMiddleware } from "./middleware/page-load-tracker";
import rootReducer from "./index";
import thunk from "redux-thunk";

const configureStore = (initialState) => {
  let middleware = [thunk];

  if (process.browser) {
    middleware = [...middleware, pageLoadTrackerMiddleware()];
  }

  const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify options like name, actionsBlacklist, actionsCreators,
          // serialize...
        })
      : compose;

  const enhancer = composeEnhancers(
    applyMiddleware(...middleware)
    // other store enhancers if any
  );

  const store = createStore(
    combineReducers({
      rootReducer,
    }),
    initialState,
    enhancer
  );

  if (module.hot && process.env.NODE_ENV === "development") {
    // Hot reload rootReducer (requires Webpack or Browserify HMR to be enabled)
    module.hot.accept("./index", () =>
      store.replaceReducer(require("./index").default)
    );
  }

  return store;
};

export default configureStore;
